import StadiumRemote from '../remote/stadiumRemote'
import { APPLICATION_STRINGS } from '../strings'
import { bridge_sendPrintStatus } from './bridgeCalls/VNWebSDKDataSend'

export const sendEmailJob = async (emailData) => {
  try {
    await StadiumRemote.sendEmailJobToStadium(emailData)
    bridge_sendPrintStatus(false, APPLICATION_STRINGS.EMAIL_SENT)
  } catch (err) {
    bridge_sendPrintStatus(true, APPLICATION_STRINGS.EMAIL_FAILED)
  }
}
